<template>
<div class="row">
  <div class="col-sm-6 col-md-4 col-md-offset-4">
      <div class="account-wall">
        <h1 class="text-center">
          Login
        </h1>
        <img class="profile-img" 
        src="../assets/icon.png"
            alt="">
        <form class="form-signin">
          <input type="text" class="form-control" placeholder="Gebruikersnaam" v-model="username" required autofocus>
          <input type="password" class="form-control" placeholder="Wachtwoord" v-model="password" required>
          <button class="btn btn-lg btn-primary btn-block" type="submit" @click="login($event)">
            Login
          </button>
          <p class="text-danger" v-if="error" v-text="error"></p>
        </form>
      </div>
  </div>
</div>
</template>


<script>
import store from '../store.js'

export default {
  components: {
  },
  data: function () {
    return {
      store: store,
      username: '',
      password: '',
      error: ''
    }
  },
  methods: {
    login: function (e) {
      e.preventDefault()
      var self = this
      var checkforQuery = Object.keys(self.$route.query).length === 0 && self.$route.query.constructor === Object
      store.login(self.username, self.password, function (success, message) {
        if (success) {
          if (!checkforQuery) {
            var query = self.$route.query
            console.log(query)
            self.$route.router.go(query)
          }
          self.$route.router.go({name: 'Dashboard'})
        } else {
          self.error = JSON.parse(message.responseText).error_description
        }
      })
    }
  }
}
</script>

<style scoped>
.form-signin
{
    max-width: 330px;
    padding: 15px;
    margin: 0 auto;
}
.form-signin .form-signin-heading, .form-signin .checkbox
{
    margin-bottom: 10px;
}
.form-signin .checkbox
{
    font-weight: normal;
}
.form-signin .form-control
{
    position: relative;
    font-size: 16px;
    height: auto;
    padding: 10px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}
.form-signin .form-control:focus
{
    z-index: 2;
}
.form-signin input[type="text"]
{
    margin-bottom: -1px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}
.form-signin input[type="password"]
{
    margin-bottom: 10px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}
.account-wall
{
    padding: 10px 0px 20px 0px;
    background-color: #f7f7f7;
    -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}
.login-title
{
    color: #555;
    font-size: 18px;
    font-weight: 400;
    display: block;
}
.profile-img
{
    width: 96px;
    height: 96px;
    margin: 0 auto 10px;
    display: block;
}
</style>


// WEBPACK FOOTER //
// login.vue?a130ea10